import React from 'react';
import { Link } from 'react-router-dom';

// Minimal monochrome 404 for the catch-all route. Head handling (noindex +
// document.title) lives centrally in App's SeoManager, which recognizes
// unknown pathnames; this component is purely visual. A true HTTP 404 status
// is not possible behind the SPA catch-all rewrite, so noindex is the
// mitigation for soft-404s.
export const NotFound: React.FC = () => (
  <div className="min-h-screen pt-36 md:pt-44 pb-24 container mx-auto px-4 md:px-6 flex flex-col items-center text-center">
    <span className="text-[11px] md:text-xs font-semibold uppercase tracking-[0.25em] text-zinc-400 dark:text-zinc-500 [.nardogrey_&]:text-zinc-300">
      404
    </span>
    <h1 className="mt-4 text-4xl md:text-5xl font-light tracking-tight text-zinc-900 dark:text-white/90 [.nardogrey_&]:text-white">
      Page not found
    </h1>
    <p className="mt-4 max-w-md text-sm md:text-base leading-relaxed text-zinc-500 dark:text-zinc-400 [.nardogrey_&]:text-zinc-300">
      The page you are looking for does not exist or has moved.
    </p>
    <Link
      to="/"
      className="mt-8 inline-flex items-center gap-2 rounded-full bg-zinc-900 px-6 py-2.5 text-sm font-medium text-white shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0 dark:bg-white dark:text-zinc-900"
    >
      Back to Home
    </Link>
  </div>
);
